<template>
    <div>
        <label><input type="checkbox" v-model="block.showInNavigation" ref="showInNavigation"> In Navigation anzeigen</label>
        <text-input :value="block.name" label="Name" ref="name"></text-input>
        <long-text-input :value="block.text" label="Text" ref="text"></long-text-input>
        <button class="btn btn-primary" @click="save">Save</button>
    </div>
</template>
<script>
export default {
  props: ["project", "blockData"],
  data() {
    return {
      block: this.blockData
    };
  },
  methods: {
    save() {
      let form = new FormData();
      if (this.block.showInNavigation)
        form.append(
          "edit_quotation_block[showInNavigation]",
          this.block.showInNavigation
        );
      form.append("edit_quotation_block[submit]", 1);

      Promise.all([
        this.$refs.name.save(),
        this.$refs.text.save(),
        axios.post(
          "/api/" + store.state.language + "/block/" + this.block.id + "/edit",
          form
        )
      ]).then(() => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Blocks/QuotationBlock.vue